import { get2 } from "@/shared/axios";
import useAccountQuery from "@/shared/hooks/useAccountQuery";
import useBranchId from "@/shared/hooks/useBranchId";
import useIsKioskUser from "@/shared/hooks/useIsKioskUser";
import { getCashDroBridge } from "@/shared/utils/cashDro";
import { CashDroSettings } from "@/shared/v2/queries/interfacesV2";
import { useQuery } from "@tanstack/react-query";

const useCashDroSettingsQuery = () => {
  const branch = useBranchId();
  const bridge = getCashDroBridge();
  const { data: account } = useAccountQuery();
  const isKioskUser = useIsKioskUser();

  const query = useQuery<CashDroSettings>({
    queryKey: ["cashDroSettings", branch],
    queryFn: () => get2(`internal/secure/pos/v1/cashdro/settings/${branch}`),
    // Kiosk users get 403 on this endpoint, wait for the account to know the role
    enabled: Boolean(branch) && Boolean(bridge) && !!account && !isKioskUser,
    staleTime: Infinity,
  });

  return query;
};

export default useCashDroSettingsQuery;
